import { fetchApi } from '@/config/axiosSetting';
import {
  GetCulpritImageTabsAlertsQueryParamType,
  GetCulpritImageTabsAlertsResponseQueryType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritImageTabsAlerts/getCulpritImageTabsAlertsQuery.type';

export const getCulpritImageTabsAlertsQueryFunctions = (
  params: GetCulpritImageTabsAlertsQueryParamType,
): Promise<GetCulpritImageTabsAlertsResponseQueryType> =>
  fetchApi.get(
    `property/reports/${params.id}/accident_users/culprit/images/entry_tabs/alerts/`,
  );
